import { render, staticRenderFns } from "./MaintenanceCommentFormNew.vue?vue&type=template&id=9bbd152e"
import script from "./MaintenanceCommentFormNew.vue?vue&type=script&lang=js"
export * from "./MaintenanceCommentFormNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports